import { forwardRef } from 'react';

import {
  Typography as Text,
  TypographyProps as TextProps,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

const styles = createStyles({
  root: {},
});

export interface ExpressionValueProps
  extends Omit<TextProps, 'classes'>,
    WithStyles<typeof styles> {}

const ExpressionValue = forwardRef<HTMLDivElement, ExpressionValueProps>(
  (props, ref) => {
    const { classes, className, ...rest } = props;
    return (
      <Text
        ref={ref}
        className={classNames(className, classes?.root)}
        {...rest}
      />
    );
  },
);

ExpressionValue.displayName = 'Expression.Value';

export default withStyles(styles)(ExpressionValue);
